import React from 'react';
import {Alert, Button, Table} from 'reactstrap';
import fetch from "./fetch";
import {setTitle} from "./util";

class Patients extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            patients: [],
        };

        this.patientPairAction = this.patientPairAction.bind(this);
        this.getPatients();
    }

    componentWillMount() {
    }

    componentDidMount() {
        setTitle('Patient Management');
    }

    // 0 -> unpair, 1 -> pair
    patientPairAction(patientId, action) {
        fetch('/api/v1/patient-pair', {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'Content-type': `application/json`
            },
            body: JSON.stringify({
                patient_ddx_id: patientId,
                pair: action
            })
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }

                this.getPatients();
            })
            .catch((err) => {
                console.error('Could not change patient pair status', err);
            });
    }

    getPatients() {
        fetch('/api/v1/paired-patients', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                let body = await resp.json();
                this.setState({
                    patients: body ? body : []
                });
            })
            .catch((err) => {
                console.error('Could not fetch patients', err);
            });
    }

    onDismiss() {
        this.setState({
            visible: false
        });
    }


    render() {
        let patients = [];

        for (let patient of this.state.patients) {
            patients.push(
                <tr>
                    <th scope="row">
                        <p>{patient.pairing_patient_info ? patient.pairing_patient_info.first_name + " " + patient.pairing_patient_info.last_name : "DDX ID: " + patient.pairing_patient}</p>
                    </th>
                    <th>
                        <p>Linked with {patient.pairing_manufacturer_text}</p>
                    </th>
                    <th>
                        <Button onClick={(e) => this.patientPairAction(patient.pairing_patient, "0")} color="danger">Un-pair</Button>
                    </th>
                </tr>
            );
        }

        return (
            <div>
                <h2 id="title">Patient Management</h2> <br />
                <Alert color="info" isOpen={this.state.visible} toggle={this.onDismiss.bind(this)}>
                    Message
                </Alert>
                <div className="d-flex flex-row justify-content-between p-5">
                    <Table hover>
                        <thead>
                            <th>Patient</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </thead>
                        <tbody>
                        {patients}
                        </tbody>
                    </Table>
                </div>
                <div className="d-flex flex-row justify-content-end">
                </div>
            </div>
        );
    }
}

export default Patients;